// extracted by mini-css-extract-plugin
export default {"navigation":"style-module--navigation--1fc67","whiteBg":"style-module--whiteBg--7d5e8"};